import React, { useEffect } from 'react';
import {
	MenuList,
	MenuListItem,
	MenuSection,
	MenuSectionHeading,
} from '@atlaskit/navigation-system';
import { useIntl } from '@atlassian/jira-intl';
import { useProjectsAnalyticsL2 } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/controllers/use-projects-analytics-l2/index.tsx';
import { RECENT_SECTION } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/project-content-section.tsx';
import messages from '../messages.tsx';
import type { RecentItemsType } from '../types.tsx';

export function RenderRecentSection({ recentItems }: { recentItems: RecentItemsType }) {
	const { formatMessage } = useIntl();
	const { sendProjectMenuContentSectionAnalyticsEvent } = useProjectsAnalyticsL2();

	useEffect(() => {
		sendProjectMenuContentSectionAnalyticsEvent({ projectSection: RECENT_SECTION });
	}, [sendProjectMenuContentSectionAnalyticsEvent]);

	return (
		recentItems.hasItems && (
			<MenuListItem testId="navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.recent-section.recent-section">
				<MenuSection>
					<MenuSectionHeading>{formatMessage(messages.recent)}</MenuSectionHeading>
					<MenuList>{recentItems.list}</MenuList>
				</MenuSection>
			</MenuListItem>
		)
	);
}
